import React from 'react'
import { config } from '../../config'
import { Brand, HelpLink, Main, Page, TopBar } from './SignInShell.styles'

/**
 * The page chrome around the sign-in card: warm cream surface, the brand top
 * bar with its "Get the app" link, and a centered main slot. Shared by the login
 * page and the Join page so a visitor who signs in on an invitation sees one
 * continuous surface, not two designs.
 */
const SignInShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<Page>
		<TopBar>
			<Brand href={config.getOrbitUrl} target="_blank" rel="noreferrer">
				<img src="/orbit-icon.svg" alt="Orbit" />
				<b>Orbit</b>
			</Brand>
			<HelpLink href={config.getOrbitUrl} target="_blank" rel="noreferrer">
				<b>Download the Mobile App</b>
			</HelpLink>
		</TopBar>
		<Main>{children}</Main>
	</Page>
)

export default SignInShell
